import { useState } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { Button } from 'shared/ui/button'
import { useDialogBottomSheet } from 'shared/ui/dialog-bottom-sheet/lib'

import s from './styles.module.scss'

interface DeleteObjectDialogProps {
  onConfirm: () => Promise<void>
  onError: (error: unknown) => void
}

export const DeleteObjectDialog = ({
  onConfirm,
  onError,
}: DeleteObjectDialogProps) => {
  const { t } = useTranslation()
  const { closeDialog } = useDialogBottomSheet()
  const [isLoading, setIsLoading] = useState(false)

  const handleDelete = async () => {
    if (isLoading) {
      return
    }

    setIsLoading(true)

    try {
      await onConfirm()
    } catch (error) {
      setIsLoading(false)
      onError(error)
    }
  }

  return (
    <div className={s.container}>
      <div className={s.info}>
        <p className={clsx('bold-20', s.title)}>
          {t('kyrgyzstan_block.edit_object.delete_dialog.title')}
        </p>
        <p className={clsx('regular-14', s.description)}>
          {t('kyrgyzstan_block.edit_object.delete_dialog.description')}
        </p>
      </div>

      <div className={s.buttons}>
        <Button
          type="button"
          variant="danger"
          borderRadius="md"
          className={clsx('semi-bold-17', s.button)}
          disabled={isLoading}
          loading={isLoading}
          onClick={handleDelete}
        >
          {t('kyrgyzstan_block.edit_object.delete_dialog.confirm')}
        </Button>

        <Button
          type="button"
          variant="transparentBlue"
          borderRadius="nr"
          className={clsx('bold-17', s.button, s.cancelButton)}
          disabled={isLoading}
          onClick={closeDialog}
        >
          {t('kyrgyzstan_block.edit_object.delete_dialog.cancel')}
        </Button>
      </div>
    </div>
  )
}
